<template>
  <div class="aside">
    <XIcon />
    <div class="menu-box">
      <el-menu
        router
        :default-active="$route.path"
        class="menu"
        :default-openeds="['1', '2', '3', '4', '5']"
      >
        <el-submenu index="1">
          <template slot="title">
            <svg>
              <use href="#live-broadcast-management" />
            </svg>
            <span>直播管理</span>
          </template>
          <el-menu-item index="1-1">直播中控台</el-menu-item>
          <el-menu-item index="1-2">直播商品计划</el-menu-item>
          <el-menu-item index="/simulation/buyin/live/provide"
            >直播间发券</el-menu-item
          >
          <el-menu-item index="/simulation/buyin/live/goods">直播商品管理</el-menu-item>
          <el-menu-item index="1-5">脚本预审</el-menu-item>
          <el-menu-item index="1-6">直播预告</el-menu-item>
          <el-menu-item index="1-7">直播设置</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <svg>
              <use href="#window-management" />
            </svg>
            <span>橱窗管理</span>
          </template>
          <el-menu-item index="2-1">橱窗商品管理</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <svg>
              <use href="#ad-tool" />
            </svg>
            <span>巨量千川</span>
          </template>
          <el-menu-item index="3-1">直播推广</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <svg>
              <use href="#marketing-management" />
            </svg>
            <span>营销管理</span>
          </template>
          <el-menu-item index="4-1">红包管理</el-menu-item>
          <el-menu-item index="4-2">主播券管理</el-menu-item>
          <el-menu-item index="4-3">超级福袋</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <svg>
              <use href="#regulation-penalty" />
            </svg>
            <span>违规管理</span>
          </template>
          <el-menu-item index="5-1">账号违规管理</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div class="content">
      <div class="x-container">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import XIcon from "../components/icon.vue";
export default {
  components: {
    XIcon,
  },
  created() {
    console.log(this.$route);
  },
};
</script>

<style lang="less" scoped>
.aside {
  margin-top: 16px;
  flex: 1;
  display: flex;
  flex-direction: row;

  .menu-box {
    height: calc(100vh - 64px - 16px);
    transition: all 0.2s;
    padding: 8px;
    margin-top: 16px;
    background-color: #fff;

    flex: 0 0 184px !important;
    max-width: 184px !important;
    min-width: 184px !important;
    position: fixed;
    top: 64px;
    width: 184px !important;
    z-index: 999;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }

  ::v-deep  .el-menu {
    border: none;

    &.el-menu--inline {
      padding: 2px 0;
    }

    .el-submenu {
      margin: 6px 0;
      .el-submenu__title {
        margin-top: 4px;
        margin-bottom: 4px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: 500;
        padding: 0;
        padding-left: 8px !important;
        display: flex;
        align-items: center;

        &:hover {
          background: none;
          color: #6557fa;
        }

        .el-submenu__icon-arrow {
          right: 4px;
        }
      }

      &.is-active {
        .el-submenu__title {
          color: #6557fa;
        }
      }

      .el-menu-item {
        min-width: 0;
        height: 36px;
        font-size: 12px;
        font-weight: unset;
        line-height: 36px;
        margin: 2px 0;
        display: flex;
        align-items: center;
        padding-left: 32px !important;

        &.is-active {
          background-color: #f5f5ff;
          border-radius: 4px;
          color: #6557fa;
          &::before {
            background-color: #6557fa;
            border-radius: 4px;
            content: "";
            display: inline-block;
            height: 12px;
            left: 0;
            position: absolute;
            width: 2px;
          }
        }

        &:hover {
          background-color: #f5f5ff;
          border-radius: 4px;
          color: #6557fa;
        }
      }
    }
  }

  .menu {
    svg {
      height: 16px;
      width: 16px;
      margin-right: 8px;
      fill: currentColor;
    }
  }

  .content {
    padding-left: 200px;

    .x-container {
      width: 1136px;
      background: #fff;
      border: none;
      border-radius: 4px;
      flex: 1;
      margin-bottom: 16px;
      min-height: calc(100vh - 96px);
      overflow: auto;
      position: relative;
    }
  }
}
</style>